/* eslint-disable react/jsx-no-bind, react/forbid-prop-types, jsx-a11y/anchor-is-valid, react/no-danger */
import React from 'react';
import PropTypes from 'prop-types';
import { when, toJS } from 'mobx';
import { withRouter } from 'react-router-dom';
import { observer, inject } from 'mobx-react';
import Loader from '../../components/loader';
import {
  trackGatekeeperLoad,
  trackDeflection,
  trackSuggestionClick,
} from '../../utils/index';
import styles from './style.css';

@withRouter
@inject('formStore')
@inject('settingsStore')
@observer
export default class GateKeeper extends React.Component {
  static propTypes = {
    formStore: PropTypes.shape({
      ticketUid: PropTypes.string,
      hasGateKeeperEnabled: PropTypes.bool,
    }).isRequired,
    settingsStore: PropTypes.shape({
      navigateArticle: PropTypes.func.isRequired,
      externalNavigation: PropTypes.bool.isRequired,
    }).isRequired,
    history: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);
    if (props.formStore.hasGateKeeperEnabled) {
      this.removeWatcher = when(
        () =>
          props.formStore.shouldSearch === false &&
          props.formStore.fetching === false,
        () => this.onHaveSuggestions()
      );
    }
  }

  componentDidMount() {
    const { history, formStore } = this.props;
    const {
      hasGateKeeperEnabled,
      hasGatekeeperMappedValues,
      fetch,
      shouldSearch,
      reset,
      sent,
    } = formStore;

    if (!hasGateKeeperEnabled && !sent) {
      history.push('/gatekeeper-notify');
      return;
    }

    if (sent || (hasGateKeeperEnabled && !hasGatekeeperMappedValues)) {
      reset();
      history.replace('/');
      return;
    }

    if (shouldSearch) {
      fetch();
    }
  }

  componentWillUnmount() {
    if (this.props.formStore.hasGateKeeperEnabled && this.removeWatcher) {
      this.removeWatcher();
    }
  }

  onHaveSuggestions = () => {
    const { formStore, settingsStore } = this.props;
    const { fields, form, searchKeywords, ticketUid, suggestions } = formStore;

    const transformedSuggestions = toJS(formStore.suggestions);

    if (transformedSuggestions.length === 0) {
      this.onHelpedNo();
    }
    trackGatekeeperLoad(
      settingsStore.trackEvent,
      fields,
      form,
      searchKeywords,
      ticketUid,
      suggestions
    );
  };

  onArticleHelped = (article) => {
    const { history, formStore, settingsStore } = this.props;
    const {
      fields,
      suggestions,
      searchKeywords,
      ticketUid,
      form,
      setArticleHelped,
    } = formStore;

    trackDeflection(
      settingsStore.trackEvent,
      fields,
      form,
      suggestions,
      searchKeywords,
      ticketUid,
      article.id
    );
    setArticleHelped();
    history.push('/gatekeeper-notify');
  };

  onHelpedNo = () => {
    const { history, formStore, settingsStore } = this.props;
    const { suggestions, searchKeywords, ticketUid, form, save, fields } =
      formStore;

    trackDeflection(
      settingsStore.trackEvent,
      fields,
      form,
      suggestions,
      searchKeywords,
      ticketUid
    );
    save();
    history.push('/gatekeeper-notify');
  };

  navigateToArticle = (id, event) => {
    event.preventDefault();
    const { settingsStore } = this.props;
    const { trackEvent, navigateArticle } = settingsStore;
    const { ticketUid } = this.props.formStore;

    trackSuggestionClick(trackEvent, id, ticketUid);
    navigateArticle(id);
  };

  hasSuggestions = () => {
    const { suggestions } = this.props.formStore;
    const transformedSuggestions = toJS(suggestions);
    return transformedSuggestions && !!transformedSuggestions.length;
  };

  handleGoBack = (e) => {
    e.preventDefault();
    this.props.history.go(-1);
  };

  renderSuggestion = (article) => {
    const { locales } = this.props.settingsStore;
    const solvedText = locales.modules.support.this_solved;
    const showArticleText = locales.modules.support.show_article;
    return (
      <article key={article.id} className={styles.suggestionItem}>
        <h4
          className={styles.suggestionTitle}
          dangerouslySetInnerHTML={{ __html: article.title }}
        />

        <div className={styles.suggestionsBodyWrapper}>
          {article.body.map((html, i) => (
            <div
              key={i} // eslint-disable-line
              className={styles.suggestionBody}
              dangerouslySetInnerHTML={{ __html: html }}
            />
          ))}
        </div>

        <div className={styles.suggestionButtonWrapper}>
          <button
            className={styles.suggestionHelpedButton}
            onClick={() => this.onArticleHelped(article)}
          >
            {solvedText}
          </button>

          <button
            className={styles.suggestionReadButton}
            onClick={(e) => this.navigateToArticle(article.id, e)}
          >
            {showArticleText}
          </button>
        </div>
      </article>
    );
  };

  renderSuggestions = () => {
    const { suggestions } = this.props.formStore;
    const transformedSuggestions = toJS(suggestions);
    return (
      <div className={styles.suggestions}>
        {this.hasSuggestions() && (
          <div className={styles.suggestionList}>
            {transformedSuggestions.map(this.renderSuggestion)}
          </div>
        )}
      </div>
    );
  };

  renderNextBar = () => {
    const { locales } = this.props.settingsStore;
    const sendText = locales.modules.support.send_ticket;
    const presubmit = locales.modules.support.presumbmit;
    const or = locales.modules.support.or;

    return (
      <div>
        {this.hasSuggestions() && (
          <section className={styles.nextBar}>
            <button onClick={this.onHelpedNo} className={styles.footerButtonNo}>
              {sendText}
            </button>

            <div className={styles.nextORText}>{or}</div>

            <p className={styles.nextBarSuggestionsText}>{presubmit}</p>
          </section>
        )}
      </div>
    );
  };

  render() {
    const { locales, externalNavigation } = this.props.settingsStore;
    const showBack = !externalNavigation;
    const { fetching } = this.props.formStore;

    return (
      <div className={styles.page}>
        <div className={styles.body}>
          <div className={styles.header}>
            {showBack && (
              <div className={styles.navigation}>
                <button className={styles.button} onClick={this.handleGoBack}>
                  {locales.general.back}
                </button>
              </div>
            )}
          </div>

          {fetching === false && this.renderNextBar()}

          <div className={styles.results}>
            {fetching && <Loader className={styles.loader} />}
            {fetching === false && this.renderSuggestions()}
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/gatekeeper/index.js